import React, { useEffect, useState } from "react";
import { useAuth } from "../auth/FirebaseAuth.js";
import { useNavigate } from "react-router-dom";
import { getUserById } from "../models/UserFunctions.js";
import { getOrgByRef } from "../models/OrgFunctions.js";
import Row from "../layout/Row.js";
import Column from "../layout/Column.js";
import Divider from "../layout/Divider.js";
import Space from "../layout/Space.js";
import Icon1 from "../icons/Icon.js";
import MLTFGPT2 from "../textfields/MLTFGPT2.js";
import DropDown1 from "../dropdowns/DropDown1.js";
import CheckBoxGrey from "../textfields/CheckBoxGrey.js";
import PrimaryButton from "../buttons/PrimaryButton.js";
import createNewExpert from "../api/create/createNewExpert.js";
import { useSnackbar } from "notistack";
import { set } from "date-fns";
import SmallSpinner from "../loading/SmallSpinner.js";
import { Skeleton } from "@mui/material";
import { useAppContext } from "../config/AppContext.js";
import Modal1 from "../modals/Modal1.js";
import SecondaryButton from "../buttons/SecondaryButton.js";
import {
  createDoc,
  getArrayDocDataByRef,
  getDocDataById,
  getDocDataByRef,
  getFlutterTime,
  queryCollection,
  updateDocDataField,
} from "../models/DataFunctions.js";
import sendInvite from "../api/send/sendInvite.js";
import TextField2 from "../textfields/TextField2.js";
import MLTFGPT1 from "../textfields/MLTFGPT1.js";
import { deleteDoc } from "firebase/firestore";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi.js";
import createDocApi from "../api/database/createDocApi.js";
import {
  collection,
  query,
  onSnapshot,
  getFirestore,
} from "firebase/firestore";
import { db } from "../config/FirebaseConfig.js";
import TabGPT from "../tabs/TabGPT.js";

function Forum({ userData, orgData, navigateWorkspace }) {
  const { currentUser, loading } = useAuth();

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  // State variables to store the input values

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const saved_data = appState.saved_data;

  const [posts, setPosts] = useState([]);

  const [infos_open, setInfosOpen] = useState(false);
  const [new_post_open, setNewPostOpen] = useState(false);

  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");

  const [selected_post, setSelectedPost] = useState(null);
  const [commenting, setCommenting] = useState(false);

  const [modifed_post, setModifedPost] = useState(null);

  const [comment_content, setCommentContent] = useState("");
  const [openModify, setOpenModify] = useState(false);

  const [activetab, setActivetab] = useState("freetalk");
  const tabs = [
    {
      label: "Echanges libres",
      id: "freetalk",
    },
    {
      label: "Questions",
      id: "questions",
    },
    {
      label: "Fonctionnalités",
      id: "features",
    },
    {
      label: "Veille réglementaire",
      id: "reglementation",
    },
  ];

  useEffect(() => {
    if (currentUser) {
      handleFetchData();
    }
  }, [currentUser, saved_data]);

  const handleSavePseudo = async () => {
    try {
      // Update the user's pseudo
      await updateDocDataFieldApi(
        userData.ref,
        "pseudo",
        userData.pseudo,
        prefix
      );

      // Show success message
      handleClickVariant("Pseudo mis à jour", "success");
    } catch (error) {
      console.error("Error saving pseudo:", error);
      handleClickVariant("Erreur lors de la mise à jour du pseudo", "error");
    }
  };

  const setOpenModifyPost = (post) => {
    setOpenModify(true);
    setTitle(post.title);
    setContent(post.content);
    setModifedPost(post);
  };

  useEffect(() => {
    // Create a Firestore Query (Ensure queryCollection returns a Query, not a Promise)
    const postsQuery = query(collection(db, "post")); // Modify this according to your filters

    const unsubscribe = onSnapshot(postsQuery, async (snapshot) => {
      const posts = snapshot.docs.map((doc) => ({
        id: doc.id,
        ref: doc.ref,
        ...doc.data(),
      }));

      // Fetch user details
      const users_posts = await getArrayDocDataByRef(
        posts.map((p) => p.user_id)
      );

      // Merge user details into posts
      const new_posts = posts.map((p) => {
        const user_post = users_posts.find((user) => user.id === p.user_id);
        return {
          ...p,
          pseudo: user_post?.pseudo || "Unknown",
          banned: user_post?.forum_banned || false,
          email: user_post?.email || "Unknown",
        };
      });

      setPosts(new_posts);
    });

    // Cleanup listener on unmount
    return () => unsubscribe();
  }, []);

  // Fetch user, org, clients, and article data
  const handleFetchData = async () => {
    if (userData) {
      try {
        if (userData.pseudo === undefined) {
          userData.pseudo = userData.display_name;
          await updateDocDataFieldApi(
            userData.ref,
            "pseudo",
            userData.display_name,
            prefix
          );
        }

        // Update state with fetched data
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  const handleModifyPost = async () => {
    try {
      if (title)
        await updateDocDataFieldApi(modifed_post.ref, "title", title, prefix);
      await updateDocDataFieldApi(modifed_post.ref, "content", content, prefix);
      handleClickVariant("Post modifié", "success");
      setOpenModify(false);
      setTitle("");
      setContent("");
    } catch (error) {
      console.error("Error modifying post:", error);
      handleClickVariant("Erreur lors de la modification du post", "error");
    }
  };

  const handleShadowPost = async (e, post) => {
    e.stopPropagation();

    try {
      await updateDocDataFieldApi(post.ref, "hidden", !post.hidden, prefix);
      handleClickVariant("Post caché", "success");
    } catch (error) {
      console.error("Error shadowing post:", error);
      handleClickVariant("Erreur lors du cachage du post", "error");
    }
  };

  const handleAddLike = async (e, post) => {
    e.stopPropagation();

    try {
      let dislikes_user_ids = post.dislikes_user_ids || [];
      let likes_user_ids = post.likes_user_ids || [];
      if (dislikes_user_ids.includes(userData.id)) {
        await updateDocDataFieldApi(
          post.ref,
          "likes",
          post.likes ? post.likes + 1 : 1,
          prefix
        );
        dislikes_user_ids.splice(dislikes_user_ids.indexOf(userData.id), 1);
        await updateDocDataFieldApi(
          post.ref,
          "dislikes_user_ids",
          dislikes_user_ids,
          prefix
        );
      } else if (likes_user_ids.includes(userData.id)) {
        await updateDocDataFieldApi(
          post.ref,
          "likes",
          post.likes ? post.likes - 1 : 0,
          prefix
        );
        likes_user_ids.splice(likes_user_ids.indexOf(userData.id), 1);
        await updateDocDataFieldApi(
          post.ref,
          "likes_user_ids",
          likes_user_ids,
          prefix
        );
      } else {
        await updateDocDataFieldApi(
          post.ref,
          "likes",
          post.likes ? post.likes + 1 : 1,
          prefix
        );
        await updateDocDataFieldApi(
          post.ref,
          "likes_user_ids",
          post.likes_user_ids
            ? [...post.likes_user_ids, userData.id]
            : [userData.id],
          prefix
        );
      }

      handleClickVariant("Like ajouté", "success");
    } catch (error) {
      console.error("Error adding like:", error);
    }
  };

  const handleRemoveLike = async (e, post) => {
    e.stopPropagation();
    try {
      let likes_user_ids = post.likes_user_ids || [];
      let dislikes_user_ids = post.dislikes_user_ids || [];
      if (likes_user_ids.includes(userData.id)) {
        await updateDocDataFieldApi(
          post.ref,
          "likes",
          post.likes ? post.likes - 1 : 0,
          prefix
        );
        likes_user_ids.splice(likes_user_ids.indexOf(userData.id), 1);
        await updateDocDataFieldApi(
          post.ref,
          "likes_user_ids",
          likes_user_ids,
          prefix
        );
      } else if (dislikes_user_ids.includes(userData.id)) {
        dislikes_user_ids.splice(dislikes_user_ids.indexOf(userData.id), 1);
        await updateDocDataFieldApi(
          post.ref,
          "likes",
          post.likes ? post.likes + 1 : 0,
          prefix
        );
        await updateDocDataFieldApi(
          post.ref,
          "dislikes_user_ids",
          dislikes_user_ids,
          prefix
        );
      } else {
        await updateDocDataFieldApi(
          post.ref,
          "likes",
          post.likes ? post.likes - 1 : -1,
          prefix
        );
        await updateDocDataFieldApi(
          post.ref,
          "dislikes_user_ids",
          post.dislikes_user_ids
            ? [...post.dislikes_user_ids, userData.id]
            : [userData.id],
          prefix
        );
      }
      handleClickVariant("Dislike ajouté", "success");
    } catch (error) {
      console.error("Error removing like:", error);
    }
  };

  const handleDeletePost = async (post, parent_post = null) => {
    try {
      // change parent post number of childs
      if (parent_post) {
        const childs = parent_post.childs.filter((p) => p.id !== post.id);
        await updateDocDataFieldApi(parent_post.ref, "childs", childs, prefix);
      }
      if (post.childs) {
        for (let child of post.childs) {
          await deleteDoc(child);
        }
      }
      await deleteDoc(post.ref);
      handleClickVariant("Post supprimé", "success");
    } catch (error) {
      console.error("Error deleting post:", error);
      handleClickVariant("Erreur lors de la suppression du post", "error");
    }
  };

  const handleNewPost = async (type = "post", parent_post) => {
    try {
      if (userData.forum_banned === true) {
        handleClickVariant("Vous n'avez pas le droit de poster", "error");
        return;
      }
      if (type === "post") {
        const post = {
          primary: true,
          admin: userData.admin || false,
          email: userData.email,
          title: title,
          content: content,
          date: getFlutterTime(),
          user_id: userData.ref,
          org_id: userData.org_id,
          likes: 0,
          likes_user_ids: [],
          dislikes_user_ids: [],
        };
        await createDocApi("post", post, prefix);
      } else {
        const date = new Date();
        const post = {
          primary: false,
          admin: userData.admin || false,
          email: userData.email,
          content: comment_content,
          date: getFlutterTime(),
          user_id: userData.ref,
          org_id: userData.org_id,
          likes: 0,
          likes_user_ids: [],
          dislikes_user_ids: [],
        };
        const newpost = await createDocApi("post", post, prefix);

        const childs = parent_post.childs || [];
        childs.push(newpost.ref);
        await updateDocDataFieldApi(parent_post.ref, "childs", childs, prefix);
      }
      setCommentContent("");
      setContent("");
      setTitle("");
      setCommenting(false);
      handleClickVariant("Post créé", "success");
      setNewPostOpen(false);
    } catch (error) {
      console.error("Error creating post:", error);
      handleClickVariant("Erreur lors de la création du post", "error");
    }
  };

  if (loading || !currentUser || !userData) {
    return (
      <div className="h-full w-c400 pl-4 flex flex-col gap-2">
        <Space y={20} />
        <Skeleton variant="rounded" width={200} height={25} />
        <Divider orientation="horizontal" />
        <Space y={10} />
        <div align="left" className="w-full pr-2 flex flex-col" y={10}>
          {/* Skeletons for text fields */}
          <Skeleton variant="rounded" width="100%" height={30} />
          <Space y={10} />
          <Skeleton variant="rounded" width="100%" height={30} />
          <Space y={10} />
          <Skeleton variant="rounded" width="100%" height={30} />
          <Space y={10} />

          {/* Skeletons for DatePicker and TimePicker */}
          <Skeleton variant="rounded" width="100%" height={30} />
          <Space y={10} />
          <Skeleton variant="rounded" width="100%" height={30} />
          <Space y={10} />

          {/* Skeleton for dropdowns */}
          <Skeleton variant="rounded" width="100%" height={30} />
          <Space y={10} />
          <Skeleton variant="rounded" width="100%" height={30} />
        </div>

        <Space y={10} />

        {/* Skeleton for button */}
        <div className="w-full flex flex-row-reverse">
          <Skeleton variant="rectangular" width={120} height={40} />
        </div>
      </div>
    );
  }

  return (
    <div className="flex-row w-full h-full overflow-auto flex ">
      <Modal1 isOpen={new_post_open} onClose={() => setNewPostOpen(false)}>
        <div className="bg-white p-4 rounded-xl flex flex-col gap-2 w-c500">
          <div className="text-h1 font-semibold">Nouveau post</div>
          <Divider orientation="horizontal" />
          <TextField2
            label="Titre"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          ></TextField2>
          <MLTFGPT1
            label="Contenu"
            value={content}
            onChange={(e) => setContent(e.target.value)}
            rows={10}
          ></MLTFGPT1>
          <div className="flex flex-row gap-2 justify-end">
            <SecondaryButton onClick={() => setNewPostOpen(false)}>
              Annuler
            </SecondaryButton>{" "}
            <PrimaryButton onClick={() => handleNewPost("post")}>
              Publier
            </PrimaryButton>
          </div>
        </div>
      </Modal1>
      <Modal1 isOpen={openModify} onClose={() => setOpenModify(false)}>
        <div className="bg-white p-4 rounded-xl flex flex-col gap-2 w-c500">
          <div className="text-h1 font-semibold">Modifier post</div>
          <Divider orientation="horizontal" />
          <TextField2
            label="Titre"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          ></TextField2>
          <MLTFGPT1
            label="Contenu"
            value={content}
            onChange={(e) => setContent(e.target.value)}
            rows={10}
          ></MLTFGPT1>
          <div className="flex flex-row gap-2 justify-end">
            <SecondaryButton onClick={() => setOpenModify(false)}>
              Annuler
            </SecondaryButton>{" "}
            <PrimaryButton onClick={handleModifyPost}>Publier</PrimaryButton>
          </div>
        </div>
      </Modal1>

      <div className="flex flex-col h-full  w-full gap-1 pl-4">
        <div className="text-hx font-medium mb-2">Forum</div>
        <div className="flex flex-row gap-2">
          <div
            className="border-shadow_25 border-1  rounded-full  px-2 py-1 h-fit  pr-2 text-h2 text-shadow_50  cursor-pointer hover:bg-stone-200 w-fit"
            onClick={() => {
              setInfosOpen(!infos_open);
            }}
          >
            <div className="flex flex-row gap-2 items-center">
              <Icon1
                icon_name={infos_open ? "up" : "down"}
                size={15}
                fill="grey"
              ></Icon1>
              <div>Infos</div>
            </div>
          </div>
          <div
            className="bg-primary rounded-full px-2 flex  items-center hover:bg-primary_l pr-4  text-white cursor-pointer w-fit"
            onClick={() => {
              setNewPostOpen(true);
            }}
          >
            <div className="flex flex-row gap-2 items-center text-h3">
              <Icon1 icon_name="plus" size={20} fill="white"></Icon1>
              <div>Créer un nouveau post</div>
            </div>
          </div>
        </div>
        {infos_open && (
          <>
            {" "}
            <div className="flex flex-col max-w-c600">
              {" "}
              <Space y={5} />
              <div className="text-h3 text-shadow_50">
                Le forum permet de poser des questions et de proposer de
                nouvelles fonctionnalités.
              </div>{" "}
              <Space y={5} />
              <div className="text-h3 text-shadow_50">
                Vous pouvez voter pour les questions et les fonctionnalités que
                vous trouvez les plus intéressantes.
              </div>
              <Space y={15} />
              <div className="text-h3 text-shadow_50">
                Vous pouvez modifier votre pseudo.
              </div>
              <Space y={5} />
              <div className="flex flex-row gap-2">
                <TextField2
                  label="Pseudo"
                  className="max-w-c200"
                  value={userData.pseudo || ""}
                  onChange={(e) => {
                    setUserData({ ...userData, pseudo: e.target.value });
                  }}
                ></TextField2>
                <SecondaryButton onClick={handleSavePseudo} className="w-fit">
                  Enregistrer
                </SecondaryButton>
              </div>
            </div>{" "}
          </>
        )}
        <div className="mt-4">
          <TabGPT
            tabs={tabs}
            activeTab={activetab}
            setActiveTab={setActivetab}
          />
        </div>
        <Space y={15} />
        {activetab === "freetalk" && (
          <div className="flex flex-col gap-6 w-full overflow-y-auto h-full pb-20">
            {posts
              .filter((post) =>
                post.primary === undefined ? true : post.primary
              )
              .filter((post) => !post.hidden || userData.admin)
              .sort((a, b) => b.likes - a.likes)
              .map((post, index) => (
                <div className="flex flex-col gap-2 max-w-c800" key={index}>
                  <div
                    className={` rounded-xl shadow_25 px-4 py-2 flex flex-col   cursor-pointer ${post.admin ? "bg-purple-50" : "bg-white"}  border-1   ${selected_post?.id === post.id ? "border-2 border-blue-300" : "border-transparent hover:border-l-shadow_25"}`}
                    onClick={() => {
                      setCommenting(false);
                      setCommentContent("");
                      if (selected_post?.id === post.id) {
                        setSelectedPost(null);
                      } else {
                        setSelectedPost(post);
                      }
                    }}
                  >
                    <div className="flex flex-row justify-between w-full">
                      <div className="flex flex-col w-full">
                        <div className="text-h2 font-semibold">
                          {post.title}
                        </div>
                        <Space y={5} />
                        <div
                          className={`flex text-h3 text-left ${
                            selected_post?.id === post.id ? "" : "line-clamp-4"
                          }`}
                          style={{
                            whiteSpace: "pre-line",
                            display:
                              selected_post?.id === post.id
                                ? "block"
                                : "-webkit-box", // Needed for line-clamp
                            WebkitBoxOrient: "vertical", // Required for -webkit-line-clamp to work
                            overflow:
                              selected_post?.id === post.id
                                ? "visible"
                                : "hidden", // Hide overflowed text
                          }}
                        >
                          {post.content}
                        </div>{" "}
                        <Space y={10} />
                        <div className="flex flex-row gap-2">
                          <div className="flex flex-row gap-2 p-1    rounded-full w-fit items-center ">
                            <div
                              className="  cursor-pointer "
                              onClick={(e) => handleAddLike(e, post)}
                            >
                              <Icon1
                                icon_name={
                                  post.likes_user_ids?.includes(userData.id)
                                    ? "good-filled"
                                    : "good"
                                }
                                size={20}
                                fill={
                                  post.likes_user_ids?.includes(userData.id)
                                    ? "#1757ea"
                                    : "grey"
                                }
                                hover_color="black"
                              ></Icon1>
                            </div>{" "}
                            <div
                              className="  cursor-pointer"
                              onClick={(e) => handleRemoveLike(e, post)}
                            >
                              <Icon1
                                icon_name={
                                  post.dislikes_user_ids?.includes(userData.id)
                                    ? "bad-filled"
                                    : "bad"
                                }
                                size={20}
                                fill={
                                  post.dislikes_user_ids?.includes(userData.id)
                                    ? "black"
                                    : "grey"
                                }
                                hover_color="black"
                              ></Icon1>{" "}
                            </div>
                            <div className="text-h3 border-l-2 px-2 h-5 border-shadow_25 text-shadow_50 items-center">
                              {post.likes || 0}
                            </div>
                          </div>
                          <div className="flex flex-row  px-2 gap-2    rounded-full w-fit items-center ">
                            <div className="  cursor-pointer ">
                              <Icon1
                                icon_name="message"
                                size={20}
                                fill="grey"
                              ></Icon1>
                            </div>
                            <div className="text-h3  h-5 text-shadow_50 items-center">
                              {post.childs
                                // childs are references to the posts
                                ?.map((p) =>
                                  posts.find((post) => post.id === p.id)
                                )
                                .filter((p) => !p?.hidden).length || 0}
                            </div>
                          </div>{" "}
                          {userData.id === post.user_id && (
                            <div
                              className="flex flex-row  px-2 gap-2  rounded-full w-fit items-center cursor-pointer  "
                              onClick={() => setOpenModifyPost(post)}
                            >
                              <Icon1
                                icon_name="modify"
                                size={20}
                                fill="grey"
                                hover_color={"black"}
                              ></Icon1>
                            </div>
                          )}
                          {(userData.id === post.user_id || userData.admin) && (
                            <div
                              className="flex flex-row  px-2 gap-2   rounded-full w-fit items-center cursor-pointer  "
                              onClick={() => handleDeletePost(post)}
                            >
                              <Icon1
                                icon_name="delete"
                                size={20}
                                fill="grey"
                                hover_color={"red"}
                              ></Icon1>
                            </div>
                          )}
                          {userData.admin && (
                            <div
                              className="flex flex-row  px-2 gap-2   rounded-full w-fit items-center cursor-pointer  "
                              onClick={(e) => handleShadowPost(e, post)}
                            >
                              <Icon1
                                icon_name="invisible"
                                size={20}
                                fill={post.hidden ? "red" : "grey"}
                                hover_color={"red"}
                              ></Icon1>
                            </div>
                          )}
                          {userData.admin && (
                            <div
                              className="flex flex-row  px-2 gap-2   rounded-full w-fit items-center cursor-pointer  "
                              onClick={(e) => {
                                e.stopPropagation();
                                navigateWorkspace("/user/" + post.user_id);
                              }}
                            >
                              <Icon1
                                icon_name="forbidden"
                                size={20}
                                fill={post.banned ? "red" : "grey"}
                                hover_color={"red"}
                              ></Icon1>
                            </div>
                          )}
                        </div>
                      </div>
                      <Space y={5} />
                      <div className="flex flex-row gap-2 h-full items-end min-w-fit">
                        <div className="text-h3 text-shadow_25">
                          {post.pseudo}
                        </div>
                        {userData.admin && (
                          <div className="text-h3 text-shadow_25">
                            {post.email}
                          </div>
                        )}

                        <div className="text-h3 text-shadow_25">
                          {new Date(
                            post.date.seconds * 1000
                          ).toLocaleDateString()}
                        </div>
                      </div>
                    </div>{" "}
                  </div>
                  {selected_post?.id === post.id && (
                    <div className="flex flex-col gap-2 h-fit">
                      <div className="flex flex-col gap-2 h-fit border-l-1 border-shadow_10 ml-10 mt-2">
                        {!commenting && (
                          <>
                            <div className="flex flex-row gap-2 justify-end  ">
                              <div
                                className="bg-primary rounded-full px-2 py-1 hover:bg-primary_l pr-4 text-h2 text-white cursor-pointer w-fit"
                                onClick={() => {
                                  setCommenting(!commenting);
                                }}
                              >
                                <div className="flex flex-row gap-2 ml-2 items-center">
                                  {" "}
                                  <div>Commenter</div>
                                  <div className="">
                                    <Icon1
                                      icon_name="response"
                                      size={20}
                                      fill="white"
                                    ></Icon1>
                                  </div>
                                </div>
                              </div>{" "}
                              <Space y={10} />
                            </div>
                          </>
                        )}
                        {commenting && (
                          <>
                            <div className="bg-white rounded-xl  p-2 mb-10 h-fit ">
                              <MLTFGPT1
                                value={comment_content}
                                onChange={(e) =>
                                  setCommentContent(e.target.value)
                                }
                                rows={5}
                              ></MLTFGPT1>
                              <div className="flex flex-row gap-2 justify-end  mt-2">
                                <div
                                  className="bg-shadow_10 rounded-full px-3 py-1 hover:bg-primary_l  text-h2 text-shadow_50 cursor-pointer w-fit"
                                  onClick={() => {
                                    setCommenting(false);
                                    setCommentContent("");
                                  }}
                                >
                                  {" "}
                                  <div>Annuler</div>
                                </div>
                                <div
                                  className="bg-primary rounded-full px-3 py-1  hover:bg-primary_l  text-h2 text-white cursor-pointer w-fit"
                                  onClick={() => handleNewPost("comment", post)}
                                >
                                  {" "}
                                  <div className="flex flex-row gap-2 items-center">
                                    {" "}
                                    <div>Poster</div>
                                    <div className="">
                                      <Icon1
                                        icon_name="send"
                                        size={15}
                                        fill="white"
                                      ></Icon1>
                                    </div>
                                  </div>
                                </div>{" "}
                              </div>
                            </div>
                          </>
                        )}
                        {posts
                          .filter((p) =>
                            post.childs?.map((p) => p.id).includes(p.id)
                          )
                          .filter((p) => !p?.hidden || userData.admin)

                          .sort((a, b) => b.likes - a.likes)
                          ?.map((child_post, index) => (
                            <div
                              key={index}
                              className={` ${child_post.email === userData.email ? "bg-blue-50" : ""} rounded-xl ml-4 shadow_25 px-4 py-2 flex flex-col border-transparent border-1  `}
                            >
                              <div className="flex flex-row justify-between w-full">
                                <div className="flex flex-col w-full">
                                  <div className="text-h2 font-semibold">
                                    {child_post.title}
                                  </div>
                                  <Space y={5} />
                                  <div
                                    className="flex text-h3  text-left"
                                    style={{ whiteSpace: "pre-line" }}
                                  >
                                    {child_post.content}
                                  </div>{" "}
                                  <Space y={10} />
                                  <div className="flex flex-row gap-2">
                                    {!child_post.admin && (
                                      <div className="flex flex-row gap-2 p-1   rounded-full w-fit items-center ">
                                        <div
                                          className="  cursor-pointer "
                                          onClick={(e) =>
                                            handleAddLike(e, child_post)
                                          }
                                        >
                                          <Icon1
                                            icon_name={
                                              child_post.likes_user_ids?.includes(
                                                userData.id
                                              )
                                                ? "good-filled"
                                                : "good"
                                            }
                                            size={20}
                                            fill={
                                              child_post.likes_user_ids?.includes(
                                                userData.id
                                              )
                                                ? "#1757ea"
                                                : "grey"
                                            }
                                            hover_color="black"
                                          ></Icon1>
                                        </div>{" "}
                                        <div
                                          className="  cursor-pointer"
                                          onClick={(e) =>
                                            handleRemoveLike(e, child_post)
                                          }
                                        >
                                          <Icon1
                                            icon_name={
                                              child_post.dislikes_user_ids?.includes(
                                                userData.id
                                              )
                                                ? "bad-filled"
                                                : "bad"
                                            }
                                            size={20}
                                            fill={
                                              child_post.dislikes_user_ids?.includes(
                                                userData.id
                                              )
                                                ? "black"
                                                : "grey"
                                            }
                                            hover_color="black"
                                          ></Icon1>{" "}
                                        </div>
                                        <div className="text-h3 border-l-2 px-2 h-5 border-shadow_25 text-shadow_50 items-center">
                                          {child_post.likes || 0}
                                        </div>
                                      </div>
                                    )}
                                    {userData.id === child_post.user_id && (
                                      <div
                                        className="flex flex-row  px-2 gap-2  rounded-full w-fit items-center cursor-pointer  "
                                        onClick={() =>
                                          setOpenModifyPost(child_post)
                                        }
                                      >
                                        <Icon1
                                          icon_name="modify"
                                          size={20}
                                          fill="grey"
                                          hover_color={"black"}
                                        ></Icon1>
                                      </div>
                                    )}
                                    {(userData.id === child_post.user_id ||
                                      userData.admin) && (
                                      <div
                                        className="flex flex-row  px-2 gap-2 rounded-full w-fit items-center cursor-pointer  "
                                        onClick={() =>
                                          handleDeletePost(child_post, post)
                                        }
                                      >
                                        <Icon1
                                          icon_name="delete"
                                          size={20}
                                          fill="grey"
                                          hover_color={"red"}
                                        ></Icon1>
                                      </div>
                                    )}
                                    {userData.admin && (
                                      <div
                                        className="flex flex-row  px-2 gap-2   rounded-full w-fit items-center cursor-pointer  "
                                        onClick={(e) =>
                                          handleShadowPost(e, child_post)
                                        }
                                      >
                                        <Icon1
                                          icon_name="invisible"
                                          size={20}
                                          fill={
                                            child_post?.hidden ? "red" : "grey"
                                          }
                                          hover_color={"red"}
                                        ></Icon1>
                                      </div>
                                    )}{" "}
                                    {userData.admin && (
                                      <div
                                        className="flex flex-row  px-2 gap-2  rounded-full w-fit items-center cursor-pointer  "
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          navigateWorkspace(
                                            "/user/" + post.user_id
                                          );
                                        }}
                                      >
                                        <Icon1
                                          icon_name="forbidden"
                                          size={20}
                                          fill={post.banned ? "red" : "grey"}
                                          hover_color={"red"}
                                        ></Icon1>
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <Space y={5} />
                                <div className="flex flex-row gap-2 h-full items-end min-w-fit">
                                  <div
                                    className={`text-h3 text-shadow_25 flex flex-row gap-1  items-center  ${child_post.admin ? "text-violet-400" : ""} `}
                                  >
                                    {child_post.pseudo}
                                    {child_post.admin && (
                                      <Icon1
                                        icon_name="admin"
                                        size={18}
                                        fill="#8b5cf6"
                                      ></Icon1>
                                    )}
                                  </div>{" "}
                                  {userData.admin && (
                                    <div className="text-h3 text-shadow_25">
                                      {child_post.email}
                                    </div>
                                  )}
                                  <div className="text-h3 text-shadow_25">
                                    {new Date(
                                      child_post.date.seconds * 1000
                                    ).toLocaleString()}
                                  </div>
                                </div>
                              </div>{" "}
                            </div>
                          ))}
                      </div>{" "}
                    </div>
                  )}
                </div>
              ))}
          </div>
        )}
        <Space y={10} />
      </div>
    </div>
  );
}

export default Forum;
